import {Form} from "@/utils/Form";
import {DomainRenameMutation, DomainRenameMutationVariables, useDomainRenameMutation} from "./mutations.generated";

class DomainSettingsRenameForm extends Form<DomainRenameMutation, DomainRenameMutationVariables> {
    constructor(domainId: number, currentName: string) {
        super("domainRename");
        this.hooks(useDomainRenameMutation, {domainId, newName: currentName});
    }

    override submit(): Promise<boolean> {
        // to refetch the domain name in the breadcrumb
        return super.submit({
            evictCaches: [
                {
                    fieldName: "domains",
                    args: {id: this.values.domainId},
                },
            ],
        });
    }
}

export default DomainSettingsRenameForm;
